import _ from "underscore";

function token() {
  return _.find(document.getElementsByTagName('meta'), (meta) => {
    return meta.name === 'csrf-token'
  }).content
}

export { token };